import { createSelector } from 'reselect';

import { RootState } from '..';

export const selectPubnub = (state: RootState) => {
  return state.pubnub;
};

export const selectIsConnected = createSelector(selectPubnub, (pubnub) => {
  return pubnub.isConnected;
});

export const selectIsInitialized = createSelector(selectPubnub, (pubnub) => {
  return pubnub.isInitialized;
});

export const selectOccupancy = createSelector(selectPubnub, (pubnub) => {
  return pubnub.occupancy.anonymous;
});

export const selectSignedUsersOccupancy = createSelector(selectPubnub, (pubnub) => {
  return pubnub.occupancy.signedIn;
});

export const selectAnonymousUsersOccupancy = createSelector(selectPubnub, (pubnub) => {
  return pubnub.occupancy.anonymous;
});

export const selectPubnubInstance = createSelector(selectPubnub, (pubnub) => {
  return pubnub.pubnub;
});

export const selectRaiseHandUsers = createSelector(selectPubnub, (pubnub) => {
  return pubnub.raiseHand.messages;
});

export const selectRaiseHandUsersTotal = createSelector(selectPubnub, (pubnub) => {
  return pubnub.raiseHand.total;
});

export const selectActiveSpeakers = createSelector(selectPubnub, (pubnub) => {
  return pubnub.activeSpeakers;
});

export const selectCurrentRaiseHandMsgTT = createSelector(selectPubnub, (pubnub) => {
  return pubnub.currentRaiseHandMsgTT;
});

export const selectCurrentReactionMsgTT = createSelector(selectPubnub, (pubnub) => {
  return pubnub.currentReactionMsgTT;
});

export const selectListenersAllowedToSpeak = createSelector(selectPubnub, (pubnub) => {
  return pubnub.listenersAllowedToSpeak;
});

export const selectReactionsCount = createSelector(selectPubnub, (pubnub) => {
  return pubnub.reactions.counts;
});

export const selectReactionsMessages = createSelector(selectPubnub, (pubnub) => {
  return pubnub.reactions.messages;
});

export const selectBlockedUsers = createSelector(selectPubnub, (pubnub) => {
  return pubnub.blocked.messages;
});

export const selectBlockedUsersCount = createSelector(selectPubnub, (pubnub) => {
  return pubnub.blocked.total;
});

export const selectIsCurrentUserBlocked = createSelector(selectPubnub, (pubnub) => {
  return Boolean(pubnub.user.blocked);
});
export const selectCurrentUserAlreadySpeakTotal = createSelector(selectPubnub, (pubnub) => {
  return pubnub.user.alreadySpeakTotal;
});

export const selectSpokeUsersMetaData = createSelector(selectPubnub, (pubnub) => {
  return pubnub.spokeUsersMetaData;
});
